// Same rule as the backend's utils/access.js. This only hides
// UI; the server makes the real decision.
const readUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); }
  catch { return {}; }
};

export const hasFullAccess = (module, user = readUser()) =>
  user?.role === 'businessman' || user?.role === 'admin' ||
  (user?.role === 'module_admin' && user?.business_module === module);
  
// Costs: everyone working in the module, operators included.
// Deletes, prices and money screens still use hasFullAccess.
export const canSeeCost = (module, user = readUser()) =>
  user?.role === 'businessman' || user?.role === 'admin' ||
  user?.business_module === module;